// extracted by mini-css-extract-plugin
module.exports = {"view":"view--2MY0X","view__title":"view__title--3Hkpa","view__description":"view__description--11cuq","view__image":"view__image--1fi2x"};